import Vue from 'vue'
import VModal from 'vue-js-modal'
import App from './App.vue'
import './style/index.less'
import router from './router'
import toastRegistry from './tools/toast'
Vue.use(VModal)
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole();
// Vue.use(vConsole)
Vue.use(toastRegistry)

Vue.config.productionTip = false
// 跳转顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title
  next()
})

Vue.mixin({
  computed: {
    lang() {
      return location.href.indexOf('/en') === -1 ? 'zh' : 'en'
    },
  },
  methods: {
    toUrl(type, url) {
      if (type === 'to') {
        window.location = url
      } else if (type === 'open') {
        window.open(url)
      }
    },
    switchLang() {
      window.location = location.href.indexOf('/en') === -1
        ? location.href.replace('/zh', '/en')
        : location.href.replace('/en', '/zh')
    },
  }
})
new Vue({
  router,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
}).$mount('#app')
